<template>
  <div>
    <notifications-modal/>
    <lead-modal/>
    <contact-modal/>
    <profile-modal/>
    <users-modal/>
    <account-modal/>
  </div>
</template>

<script>
import AccountModal from "../../modules/account/AccountModal";
import ContactModal from "../../modules/contacts/ContactModal";
import LeadModal from "../../modules/lead/LeadModal";
import ProfileModal from "../../modules/account/ProfileModal";
import UsersModal from "../../modules/account/UsersModal";
import NotificationsModal from "../../modules/account/NotificationsModal";

export default {
  name: 'HashModals',
  components: {
    NotificationsModal,
    AccountModal,
    ContactModal,
    LeadModal,
    ProfileModal,
    UsersModal
  }
}
</script>
